(function($) {
    // supported formats:
    // YMD-DASH
    // YMD-DOT
    // DMY-DASH
    // DMY-DOT
    $.fn.c24TeaserDateWidget = function(errorMessages = undefined, format = 'YMD-DASH') {
        const oElement = $(this).get(0);
        let iMinAge = oElement.getAttribute('data-min-age');
        let iMaxAge = oElement.getAttribute('data-max-age');

        if (iMinAge < 1) {
            iMinAge = 3;
        }

        if (iMaxAge < 1) {
            iMaxAge = 65;
        }

        const oErrors = errorMessages ?? {
            'notValid': 'Datum ist ungültig',
            'age': {
                'min': 'Mindestalter ' + iMinAge + ' Jahre',
                'max': 'Höchstalter ' + iMaxAge + ' Jahre',
            },
            'leapYear': 'Angegebene Jahr ist kein Schaltjahr',
            'inFuture': 'Datum liegt in der Zukunft',
            'generic': 'Es ist ein Fehler aufgetreten',
        };

        return {
            oElement: null,
            oDateMask: null,
            oDate: new Date(),
            sFinalDateValue: '',
            oUrlParamBd: null,
            sDateValue: '',
            sOldYear: '',
            bCharRemoved: false,
            iMinAge: iMinAge,
            iMaxAge: iMaxAge,
            bIsError: false,
            oErrors,
            sErrorMsg: '',
            oErrorElement: null,
            sFormat: format,
            oDateContainer: null,
            oMaskOptions: {
                mask: 'd{.}`m{.}`Y',
                blocks: {
                    d: {
                        mask: '00',
                    },
                    m: {
                        mask: '00',
                    },
                    Y: {
                        mask: '0000',
                    },
                },
                lazy: false,
                overwrite: true,
                autofix: false,
            },
            oMaskOptionsEmpty: {
                mask: 'd{.}`m{.}`Y',
                blocks: {
                    d: {
                        mask: '00',
                    },
                    m: {
                        mask: '00',
                    },
                    Y: {
                        mask: '0000',
                    },
                },
                lazy: true,
                overwrite: true,
                autofix: false,
            },

            fnInit: function(el) {

                this.oElement = el;

                const form = el.getElementsByTagName('form')[0];
                form.addEventListener('submit', this.fnOnSubmitForm.bind(this), false);

                this.oDateContainer = el.getElementsByClassName('j24ErrorToggle')[0];
                this.oErrorElement = el.getElementsByClassName('errorMsg')[0];

                this.oUrlParamBd = el.getElementsByClassName('js24ParamBd')[0];
                if (!this.oUrlParamBd) {
                    console.log('error: mod24ac date teaser is missing js24ParamBd');
                    return this;
                }

                const oDateInput = el.getElementsByClassName('js24DateInput')[0];
                if (!oDateInput) {
                    console.log('error: mod24ac date teaser is missing js24DateInput');
                    return this;
                }

                this.oDateMask = new window.C24InputMask(oDateInput, this.oMaskOptionsEmpty);

                this.oDateMask.on('accept', this.fnOnAcceptInput.bind(this));
                this.oDateMask.on('complete', this.fnOnCompleteDate.bind(this));

                this.oDateMask.value = oDateInput.getAttribute('data-inital-value');

                return this;
            },

            fnOnAcceptInput: function () {
                this.fnClearError();

                if (this.onAcceptInputActive) {
                    return;
                }

                this.onAcceptInputActive = true;

                if (this.oDateMask.value.replace(/\D/g,'').length < 1) {

                    this.oDateMask.updateOptions(this.oMaskOptionsEmpty);

                    this.onAcceptInputActive = false;
                    return;
                }

                if (this.oDateMask.masked.lazy) {

                    this.oDateMask.updateOptions(this.oMaskOptions);
                }

                let aDayMonthYear = this.oDateMask.value.split('.');
                let aDayMonthYearOriginal = [];
                const aDayMonthYearFinal = [];

                if (aDayMonthYear.length < 3) {
                    this.sFinalDateValue = '';
                    this.onAcceptInputActive = false;
                    return;
                }

                aDayMonthYear[0] = aDayMonthYear[0].replace(/\D/g,''),
                aDayMonthYear[1] = aDayMonthYear[1].replace(/\D/g,''),
                aDayMonthYear[2] = aDayMonthYear[2].replace(/\D/g,'');

                aDayMonthYearOriginal = Object.assign([], aDayMonthYear);

                // handle day month
                aDayMonthYear = this.fnHandleDayMonthSimultaneously(aDayMonthYear);

                // handle day
                aDayMonthYear[0] = this.fnAddLeadingZero(aDayMonthYear[0], 3, 'day');

                // handle month
                aDayMonthYear[1] = this.fnAddLeadingZero(aDayMonthYear[1], 1, 'month');
                aDayMonthYear[1] = this.fnHandleMonth(aDayMonthYear[0], aDayMonthYear[1]);

                // handle year
                aDayMonthYear[2] = this.fnYearPrefill(aDayMonthYear[2]);
                aDayMonthYear[2] = this.fnAddLeadingZero(aDayMonthYear[2], 10, 'year', 4);

                aDayMonthYearOriginal[0] = parseInt(aDayMonthYearOriginal[0], 10),
                aDayMonthYearOriginal[1] = parseInt(aDayMonthYearOriginal[1], 10),
                aDayMonthYearOriginal[2] = parseInt(aDayMonthYearOriginal[2], 10);

                aDayMonthYearFinal[0] = parseInt(aDayMonthYear[0].replace(/\D/g,''), 10),
                aDayMonthYearFinal[1] = parseInt(aDayMonthYear[1].replace(/\D/g,''), 10),
                aDayMonthYearFinal[2] = parseInt(aDayMonthYear[2].replace(/\D/g,''), 10);

                // update value if needed
                if (aDayMonthYearOriginal[0] !== aDayMonthYearFinal[0]
                   || aDayMonthYearOriginal[1] !== aDayMonthYearFinal[1]
                   || aDayMonthYearOriginal[2] !== aDayMonthYearFinal[2]) {

                    this.fnUpdateValueAndCursorPos(aDayMonthYear.join('.'), this.oDateMask);
                    this.sFinalDateValue = this.oDateMask.unmaskedValue;
                }

                this.onAcceptInputActive = false;
            },
            fnOnCompleteDate: function () {

                const aDayMonthYear = this.oDateMask.value.split('.');
                if (aDayMonthYear.length < 3) {
                    this.sFinalDateValue = '';
                    return;
                }

                this.sFinalDateValue = this.oDateMask.unmaskedValue;

                const sDay = aDayMonthYear[0];
                const sMonth = aDayMonthYear[1];
                const sYear = aDayMonthYear[2];

                /****** error handling start ******/
                this.fnIsLeapYear(sDay, sMonth, sYear);
                this.fnIsValidDate(sDay, sMonth, sYear);
                this.fnIsInFuture(sDay, sMonth, sYear);
                this.fnCheckMinMaxAge(sDay, sMonth, sYear);
                /****** error handling end ******/

            },
            fnAddLeadingZero: function (value, minTensDigit, sBlock, maxLength = 2) {

                const sPlaceholder = '_';

                if (value.length < maxLength && value > minTensDigit && value < 10) {
                    return '0' + value;
                }

                while (value.length < maxLength) {
                    value += sPlaceholder;
                }
                return value;
            },
            fnHandleDayMonthSimultaneously: function (aDayMonthYear) {

                let sDay = aDayMonthYear[0];
                let sMonth = aDayMonthYear[1];

                if (parseInt(aDayMonthYear[0]) > 31) {
                    sDay = '0' + aDayMonthYear[0].substring(0,1);
                    sMonth = aDayMonthYear[0].substring(1,2);
                }

                aDayMonthYear[0] = sDay;
                aDayMonthYear[1] = sMonth;

                return aDayMonthYear;
            },
            fnHandleMonth: function (sDay, sMonth) {

                const iMonth = parseInt(sMonth);

                if (iMonth > 12) {
                    return '12';
                }

                return sMonth;
            },
            fnIsLeapYear: function (sDay, sMonth, sYear) {

                // check if 29.02 is in a non leap year
                if (sYear % 4 > 0 && (sYear % 100 == 0 || sYear % 400 != 0)) {
                    if (sDay == 29 && sMonth == 2) {
                        this.fnThrowError('leapYear');

                        return false;
                    }
                }

                return true;
            },
            fnIsValidDate: function(sDay, sMonth, sYear) {

                let iMonthFromInput = parseInt(sMonth);
                const oInputDate = new Date(sYear, iMonthFromInput - 1, sDay);
                let iDayFromDate = oInputDate.getDate();
                let iMonthFromDate = oInputDate.getMonth() + 1;
                const iYearFromDate = oInputDate.getFullYear();

                if (iDayFromDate < 10 && iDayFromDate.toString().length < 2) {
                    iDayFromDate = '0' + iDayFromDate;
                }

                if (iMonthFromDate < 10 && iMonthFromDate.toString().length < 2) {
                    iMonthFromDate = '0' + iMonthFromDate;
                }

                if (iMonthFromInput < 10 && iMonthFromInput.toString().length < 2) {
                    iMonthFromInput = '0' + iMonthFromInput;
                }

                const sDateFromInput = sDay + '.' + iMonthFromInput + '.' + sYear;
                const sDateFromDate = iDayFromDate + '.' + iMonthFromDate + '.' + iYearFromDate;

                if (sDateFromInput !== sDateFromDate) {
                    this.fnThrowError('notValid');

                    return false;
                }

                return true;
            },
            fnIsInFuture: function(sDay, sMonth, sYear) {

                const iMonthFromInput = parseInt(sMonth);
                const oInputDate = new Date(sYear, iMonthFromInput - 1, sDay);
                const oCurrentDate = new Date();

                if (oCurrentDate < oInputDate) {
                    this.fnThrowError('inFuture');

                    return true;
                }

                return false;
            },
            fnYearPrefill: function (sYear) {

                let sCentury = '';
                const oDate = new Date();
                const sCurrentYear = oDate.getFullYear().toString();
                const iYear = parseInt(sYear);

                if (this.sOldYear.length > sYear.length) {
                    this.bCharRemoved = true;
                } else if (this.sOldYear.length < sYear.length) {
                    this.bCharRemoved = false;
                }

                this.sOldYear = sYear;

                if (this.bCharRemoved) {
                    return sCentury + sYear;
                }

                if (sYear.length === 2) {
                    if (iYear >= 50) {
                        sCentury = '19';
                    } else if (
                        iYear === 0 ||
                           parseInt(sYear) > sCurrentYear.substring(0, 2) ||
                           parseInt(sYear) < parseInt(sCurrentYear.substring(0, 2)) - 1 ||
                           sYear === sCurrentYear.substring(2, 4)
                    ) {
                        sCentury = '20';
                    }
                }

                return sCentury + sYear;
            },
            fnCheckMinMaxAge: function (sDay, sMonth, sYear) {

                function getAge(sDay, sMonth, sYear) {
                    const oDate = new Date(sYear, parseInt(sMonth) - 1, sDay);
                    const oNow = new Date();
                    let iYearDiff = oNow.getFullYear() - oDate.getFullYear();
                    const iMonthCurrent = oNow.getMonth();
                    const iMonthInput = oDate.getMonth();
                    const iDayCurrent = oNow.getDate();
                    const iDayInput = oDate.getDate();

                    if (iMonthInput > iMonthCurrent) {
                        iYearDiff--;
                    } else if (iDayInput > iDayCurrent) {
                        iYearDiff--;
                    }

                    return iYearDiff;
                }

                const iCalculatedAge = getAge(sDay, sMonth, sYear);

                if (iCalculatedAge >= this.iMaxAge) {
                    this.fnThrowError('age', 'max');

                    return false;
                } else if (iCalculatedAge < this.iMinAge) {
                    this.fnThrowError('age', 'min');

                    return false;
                }

                return true;
            },
            fnUpdateValueAndCursorPos: function (sNewValue, oDetail) {

                if (oDetail.value === sNewValue) {
                    return;
                }

                let iCursorMovement = sNewValue.replace(/\D/g,'').length - oDetail.value.replace(/\D/g,'').length;

                // cursor movement will be increased by the amount of dots
                if (iCursorMovement >= 2) {
                    iCursorMovement++;
                }

                if (iCursorMovement >= 4) {
                    iCursorMovement++;
                }

                oDetail.value = sNewValue;

                oDetail.adjustCursorPos = iCursorMovement;
            },
            fnThrowError: function (sType, sSpecific) {

                if (this.bIsError) {
                    return;
                }

                sType = (sType) ? sType : 'generic';
                sSpecific = (sSpecific) ? sSpecific : '';

                if (sSpecific === '') {
                    this.sErrorMsg = (this.oErrors[sType]) ? this.oErrors[sType] : this.oErrors.generic;
                } else {
                    this.sErrorMsg = (this.oErrors[sType][sSpecific]) ? this.oErrors[sType][sSpecific] : this.oErrors.generic;
                }

                this.oDateContainer.classList.add('error');

                this.oErrorElement.innerHTML = this.sErrorMsg;
                this.oErrorElement.classList.remove('c24Hidden');

                this.bIsError = true;
            },
            fnClearError: function () {

                if (!this.bIsError) {
                    return;
                }

                this.oDateContainer.classList.remove('error');

                this.oErrorElement.innerHTML = '';
                this.oErrorElement.classList.add('c24Hidden');

                this.bIsError = false;
            },
            fnOnSubmitForm: function() {

                // check if input is empty
                if (this.sFinalDateValue.replace(/\D/g,'') === '') {
                    this.oUrlParamBd.value = '';

                    return true;
                } else {
                    const aDateCheck = this.sFinalDateValue.split('.').reverse();
                    if (
                        aDateCheck.length < 3
                        || new Date(aDateCheck[0], aDateCheck[1], aDateCheck[2]) == 'Invalid Date'
                    ) {
                        this.fnThrowError('notValid');
                    }
                }

                const aDateInput = this.sFinalDateValue.split('.');
                const sFormatedDate = this.fnFormatDate(aDateInput);

                this.oUrlParamBd.value = sFormatedDate;

                if (navigator.sendBeacon) {
                    const formData = new FormData();

                    formData.append('person_birthday', sFormatedDate);
                    formData.append('product', 'Vorsorge');
                    navigator.sendBeacon(window.c24LpRoot + 'api/?k=24&a=setbpm', formData);

                } else {
                    const xhr = new XMLHttpRequest();

                    xhr.open('POST', window.c24LpRoot + 'api/?k=24&a=setbpm', true);
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr.send('person_birthday=' + sFormatedDate + '&product=Vorsorge');
                }

                return true;
            },
            fnFormatDate: function (dateValues) {
                let dateValuesSorted;
                if (this.sFormat === 'YMD-DASH' || this.sFormat === 'YMD-DOT') {
                    dateValuesSorted = dateValues.reverse();
                } else {
                    dateValuesSorted = dateValues;
                }

                if (this.sFormat === 'YMD-DASH' || this.sFormat === 'DMY-DASH') {
                    return dateValuesSorted.join('-');
                } else {
                    return dateValuesSorted.join('.');
                }
            },
        }.fnInit(oElement);
    };
})(window.jQuery);
